import {
    Dashboard as DashboardIcon,
    Settings as SettingsIcon
} from "@mui/icons-material";
import { Box } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useUser } from "src/allauth/auth";
import { MenuButton } from "src/theme/StyledFields";
import ProfileIcon from "src/theme/icons/ProfileIcon";
import { MenuProps } from "./PublicPagesMenu";

const AthleteMenu: React.FC<MenuProps> = ({ layout = 'drawer' }) => {
    const location = useLocation();
    const user = useUser();

    const menuItems = [
        { path: "/dashboard", icon: DashboardIcon, label: "Dashboard", priority: true },
        // { path: "/notifications", icon: NotificationsIcon, label: "Notifications", priority: true },
        { path: "/my-profile", icon: ProfileIcon, label: (user.display && layout === 'header') ? `${user.display}` : "My Profile", priority: false }
    ];
    if (layout !== 'header') {
        menuItems.push({ path: "/my-profile/settings", icon: SettingsIcon, label: "Settings", priority: false });
    }

    const renderItems = () => {
        return menuItems.map(({ path, icon: Icon, label }) => (
            <MenuButton
                key={path}
                component={Link}
                to={path}
                startIcon={<Icon fontSize="small" />}
                fullWidth={layout === 'drawer'}
                color={location.pathname === path ? "primary" : "inherit"}
                sx={{
                    justifyContent: layout === 'drawer' ? 'flex-start' : 'center',
                }}
            >
                {label}
            </MenuButton>
        ));
    };

    const wrapperStyles = {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexDirection: layout === 'drawer' ? 'column' : 'row'
    }

    return <Box data-menu-role="athlete" data-menu-layout={layout} sx={wrapperStyles}>
        {renderItems()}</Box>;
};

export default AthleteMenu;